import {
  useGetTradeFlowByIdQuery,
  useGetAccessControlTradeFlowByIdQuery,
} from "../store/apiSlices/tradeFlow";

type UseTradeFlowParams = {
  rowId: string | null;
  uid?: number;
  permission?: "owner" | "editor" | "viewer";
};

export function useTradeFlow({ rowId, uid, permission }: UseTradeFlowParams) {
  const isOwner = permission === "owner";
  const canUseSharedApi = permission === "editor" || permission === "viewer";

  const ownedQuery = useGetTradeFlowByIdQuery(rowId!, {
    skip: !isOwner || !rowId,
  });

  const sharedQuery = useGetAccessControlTradeFlowByIdQuery(
    { row_id: rowId!, parent_id: uid! },
    {
      skip: isOwner || !canUseSharedApi || !rowId || !uid,
    }
  );

  return isOwner ? ownedQuery : sharedQuery;
}
